import axios from 'axios';
import { endpoints } from 'utils/global-constants';

/**
 * Remove seats/tickets from cart
 * @param {string} lineItemId
 * @param {string} perfNo
 */
export const removeSeats = async (lineItemId, perfNo) => {
  try {
    const response = await axios.post(endpoints.removeSeats, {
      lineItemId,
      perf_no: perfNo,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Remove Gift certificate from cart
 * @param {string} giftCertificateNumber
 * @returns
 */
export const removeCertificate = async (giftCertificateNumber) => {
  try {
    const response = await axios.post(endpoints.removeCertificate, {
      giftCertificateNumber,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Remove Donation from cart
 * @param {string} lineItemId
 * @returns
 */
export const removeDonation = async (lineItemId) => {
  try {
    const response = await axios.post(endpoints.removeDonation, {
      lineItemId,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Remove Membership from cart
 * @param {string} lineItemId
 * @returns
 */
export const removeMembership = async (lineItemId) => {
  try {
    const response = await axios.post(endpoints.removeMembership, {
      lineItemId,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
